import { InternalLink } from "components/ui/internal-link";
import React from "react";

export const TransfersPageLink: React.FC = () => (
    <InternalLink className="underline" to="/transfers/outgoing">
        Transfers page
    </InternalLink>
);
